module.exports = {
	content: ['./**/*.php'],
	safelist: ['bg-black', 'bg-red'],
	theme: {
		// Helper pixel to rem calc: https://nekocalc.com/de/px-zu-rem-umrechner
		fontSize: {
			xxs: '0.75rem', //10px
			xs: '1rem',
			sm: '1.563rem', //25px
			base: '2.5rem',
			lg: '2.5rem',
			xl: '2.5rem',
			'2xl': '2.5rem',
			'3xl': '2.5rem',
			'4xl': '2.5rem',
			input: '2.25rem',
		},
		fontFamily: {
			sans: ['Akzidenz-Grotesk', 'Arial', 'sans-serif'],
			//mono: ['Roboto Mono', 'serif'],
			//serif: ['Roboto Serif', 'serif'],
		},
		fontWeight: {
			light: 400,
			normal: 400,
			medium: 400,
			bold: 400,
		},
		minHeight: {
		  'minHeightSpace': '120%',
		},
		extend: {
			gridTemplateColumns: {
				cart: 'min-content auto min-content min-content',
			},
			colors: {
				primary: {
					50: '#f7f7f7',
					100: '#e3e3e3',
					200: '#c8c8c8',
					300: '#a4a4a4',
					400: '#818181',
					500: '#666666',
					600: '#515151',
					700: '#434343',
					800: '#383838',
					900: '#000094',
					DEFAULT: '#000000',
				},
				secondary: {
					50: '#fdffe7',
					100: '#f8ffc1',
					200: '#f6ff86',
					300: '#f9ff41',
					400: '#fffb0d',
					DEFAULT: '#ffed00',
					600: '#d1b000',
					700: '#a67f02',
					800: '#89630a',
					900: '#74500f',
					950: '#442b04',
				},
				focus: {
					DEFAULT: '#ffffff',
					100: '#efefef',
					200: '#dcdcdc',
					300: '#bdbdbd',
					400: '#989898',
					500: '#7c7c7c',
					600: '#656565',
					700: '#525252',
					800: '#464646',
					900: '#3d3d3d',
					950: '#292929',
				},
				red: {
					DEFAULT: '#DB1C1F',
				},
				grey: 'rgba(12, 12, 12, 1)',
			},
			zIndex: {
				60: 60,
			},
		},
	},
	corePlugins: {
		aspectRatio: false,
	},
	plugins: [require('@tailwindcss/aspect-ratio'), require('@tailwindcss/forms')],
};
